<template>
  <div class="UE">
    <el-form
      :model="plan"
      status-icon
      label-width="100px"
      class="demo-ruleForm"
      label-position="left"
    >
      <el-form-item label="id" prop="pass">
        <el-input type="text" v-model="plan.id" autocomplete="off" disabled></el-input>
      </el-form-item>
      <el-form-item label="标题" prop="pass">
        <el-input type="text" v-model="plan.title" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="简介" prop="checkPass">
        <el-input type="text" v-model="plan.intro" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="标题图">
        <el-upload
          action="/upImg.php"
          list-type="picture-card"
          :on-success="handleAvatarSuccess"
          :on-remove="delete_file"
          :limit="1"
          :on-exceed="handleExceed"
          :file-list="fileList"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="内容" prop="checkPass">
        <script id="editor" type="text/plain"></script>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm">提交</el-button>
        <!-- <el-button @click="resetForm('ruleForm')">返回</el-button> -->
      </el-form-item>
    </el-form>
  </div>
</template>
<style scoped>
.UE {
  width: 1200px;
  height: 100%;
}
</style>
<script>
export default {
  name: "UE",
  data() {
    return {
      editor: null,
      fileList: [],
      plan: {
        id: 1,
        title: "标题",
        intro: "好",
        content: "<h1>内容</h1>",
        icon: ""
      }
    };
  },
  methods: {
    handleExceed(files, fileList) {
      this.$message.warning(
        `只能上传 1 张 图片 本次已上传 ${files.length} 张图片`
      );
    },
    handleAvatarSuccess(response, file, fileList) {
      this.plan.icon = response.replace(/\s/g, "");
    },
    delete_file(file, fileList) {
      var self = this;
      var data = {
        path: self.plan.icon
      };
      this.ajax("/upImg.php", "delete", JSON.stringify(data), function(data) {
        /** icon字符设置默认值 */
        self.plan.icon = "";
      });
    },
    getUEContent() {
      // 获取内容方法l
      return this.editor.getContent();
    },
    submitForm() {
      var _this = this;
      var plan_id = this.$route.params.id;
      this.plan.content = this.getUEContent();

      $.ajax({
        url: "/plan_id.php?id=" + plan_id,
        type: "patch",
        contentType: "application/json",
        data: JSON.stringify(_this.plan),
        success: function(data) {
          _this.$message({
            message: "修改成功",
            type: "success"
          });
          // console.log(data);
        }
      });
    }
  },
  destroyed() {
    this.editor.destroy();
  },
  created() {
    var _this = this;
    var plan_id = this.$route.params.id;
    $.ajax({
      url: "/plan_id.php?id=" + plan_id,
      type: "get",
      data: null,
      success: function(data, textStatus, jqXHR) {
        var plan = JSON.parse(data);
        _this.plan = plan.data;

        _this.fileList.push({
          name: plan.data.icon,
          url: "/" + plan.data.icon
        });

        _this.editor.addListener("ready", function() {
          _this.editor.setContent(_this.plan.content); // 确保UE加载完成后，放入内容。
        });
      }
    });
  },
  mounted() {
    this.editor = UE.getEditor("editor"); // 初始化UE
  }
};
</script>





// WEBPACK FOOTER //
// src/components/UE.vue